import React from 'react';

import { SearchInput } from '@repo/ui-kit/components/core/Input';

interface CreateFirstSearchBarProps {
  query: string;
  onChange: (query: string) => void;
}

export const CreateFirstSearchBar: React.FC<CreateFirstSearchBarProps> = ({
  query,
  onChange,
}) => {
  const onSearchChange = (value?: string): void => {
    onChange(value ?? '');
  };

  return (
    <div className="search-bar-wrapper">
      <SearchInput
        placeholder="Search..."
        size="m"
        value={query}
        onChanged={onSearchChange}
        onChanging={onSearchChange}
      />
    </div>
  );
};
